

// 本地
// const ApiUrl = "http://192.168.0.120:801/";//API地址
// const AgentApiUrl = 'http://192.168.0.120:802/';//代理地址

// 测试
// const ApiUrl = 'https://webapi.test.goworkla.cn/';       // http请求前缀
// const AgentApiUrl = 'https://agent.test.goworkla.cn/';   // http请求前缀
// const clientId = '59c0e143555818d2af8e4a81';

// // 预览版
// const ApiUrl = 'http://webapi.preview.goworkla.cn';       // http请求前缀
// const AgentApiUrl = 'https://agent.goworkla.cn/';   // http请求前缀
// const clientId = '59c0e143555818d2af8e4a81';

//正式产品
const ApiUrl = "https://webapi.goworkla.cn/"; //API地址
// const ApiUrl = "https://apinet6.goworkla.cn/"; //API地址
const AgentApiUrl = "https://agentnew.goworkla.cn/"; //代理地址
const clientId = '59c0e143555818d2af8e4a81';

const ClientSecret = '00000000-0000-0000-0000-000000000000';

const LocalStorage = {
    AccessToken: "accesstoken",
    configStyle: "configStyle",
    thisCollegeId: "thisCollegeId",
    d_region: "d_region"
};

export  default {
    ApiUrl: ApiUrl,
    AgentApiUrl: AgentApiUrl,
    clientId: clientId,
    ClientSecret: ClientSecret,
    LocalStorage: LocalStorage,
}
